import Price from 'snippets/price/price'
import LoaderSpin from 'snippets/loader-spin/loader-spin'

function CartTotal({ price, isFetching, cartDiscount, className = 'pb-4' }) {
  return (
    <div className={`flex justify-between ${className}`}>
      <span className="text-sm font-medium text-grey-1000">{translate.cart.subtotal}</span>
      <div className="relative flex">
        <LoaderSpin show={isFetching} />
        {cartDiscount > price
          ? <Price price={price} originalPrice={cartDiscount} className="flex flex-col text-sm font-medium" classSize="text-sm" classOriginalColor="text-grey-light" saleColorStyle={`color: ${window.minicartConfig.totalSavingColor}`} />
          : <Price price={price} className="inline-block text-sm font-medium text-grey-1000" classSize="text-sm" />
        }
      </div>
    </div>
  )
}

export default CartTotal
